<template>
  <div class="avatar-upload profile-grid">

    <div id="avatar_preview" v-if="!cropper">
      <label>{{ $t('settings.avatar_label') }}</label>
      <div>
      <Avatar :label="profile.nickname.charAt(0).toUpperCase()" size=""
        style="background-color:#2196F3; color: #ffffff; cursor: pointer;" shape="circle" v-if="!profile.avatar" />
      <Avatar :image="$utils.getAvatar(profile.avatar)" size="" style="background-color:#2196F3; color: #ffffff; cursor: pointer;"
        shape="circle" v-else />
      <Button :label="$t('settings.avatar_upload')" icon="pi pi-cloud-upload" @click="openSelector" class="ml-2"></Button>
      </div>
    </div>

    <input id="avatar_input" type="file" mode="basic" ref="image_input" accept="image/*" @change="onSelectFile"
      :chooseLabel="$t('settings.new_avatar')" />
    <div v-if="selectedFile" class="cropper-container">
      <img ref="image" :src="selectedFile"  @load="initializeCropper" />
    </div>
    <div v-if="cropper" class="controls">
      <Button @click="zoomIn" :label="$t('settings.zoom_in')" icon="pi pi-search-plus" size="small" severity="contrast"/>
      <Button @click="zoomOut" :label="$t('settings.zoom_out')" icon="pi pi-search-minus" size="small" severity="contrast"/>
      <Button @click="cropAndSave" :label="$t('settings.saveandclose')" icon="pi pi-save" size="small" />
      <Button @click="cropper = null; selectedFile = null" :label="$t('settings.cancel')" icon="pi pi-cancel" size="small"  severity="danger"/>
    </div>
  </div>
  <Toast position="bottom-right" group="br"/>

</template>


<script>
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import axios from 'axios';


export default {
  props: ['profile'],

  data() {
    return {
      selectedFile: null,
      cropper: null,
    };
  },
  methods: {
    openSelector() {
      this.$refs.image_input.click();
    },
    onSelectFile(event) {
      const file = event.target.files[0];
      if (file && file.type.startsWith('image/')) {
        this.selectedFile = URL.createObjectURL(file);
      } else {
        console.log('file not exist');
      }
    },
    initializeCropper() {
      this.$nextTick(() => {
        if (this.cropper) {
          this.cropper.destroy();
        }
        this.cropper = new Cropper(this.$refs.image, {
          aspectRatio: 1,
          viewMode: 1,
          cropBoxResizable: false,
          cropBoxMovable: false,
          dragMode: 'move',
        });
      });
    },
    zoomIn() {
      this.cropper.zoom(0.1); // Zoom değeri ölçeklenebilir
    },
    zoomOut() {
      this.cropper.zoom(-0.1); // Zoom değeri ölçeklenebilir
    },
    cropAndSave() {
      if (this.cropper) {
        const croppedCanvas = this.cropper.getCroppedCanvas();
        try {
          croppedCanvas.toBlob(async (blob) => {
            const formData = new FormData();
            formData.append('file', blob, 'avatar-image.png');
            const response = await axios.post(this.$socket_url + '/avatarUpload', formData, {
              headers: {
                'Authorization': this.$socket.authKeyUnique.auth,
                'User_ID': this.$socket.authKeyUnique.user_id
              }
            });

            if (response.status === 200) {
              this.$toast.add({ severity: 'success', summary: 'Info', detail: 'Avatar updated', life: 3000 });
            } else {
              this.$toast.add({ severity: 'error', summary: 'Info', detail: 'Avatar not updated', life: 3000 });
            }
          }, 'image/png');
        } catch (error) {
          console.error('Dosya yükleme sırasında bir hata oluştu:', error);
        }
      }
    },
  },
  beforeUnmount() {
    if (this.cropper) {
      this.cropper.destroy();
    }
  }
};

</script>

<style scoped>
#avatar_input {
  display: none;
}

.cropper-container {
  width: 100%;
  height: 200px;
  margin: auto;
  overflow: hidden;
  position: relative;
}

.controls {
  display: flex;
  justify-content: center;
  gap: 3px;
  margin-top: 10px;
  height: 25px;
}


div#avatar_preview div {
    display: flex;
}
div#avatar_preview label {
  margin-bottom: 10px;
  display: block;
}

div#avatar_preview {
    padding-top: 20px;
    border-top: 1px solid  var(--p-neutral-200);;
}
</style>
